import React from 'react';
import CommunityImg from '../../Common/CommunityImg/CommunityImg';
import { default as creativeBadge } from '../../../images/Creative_community_badge.svg';
import { default as creativeBuzzBadge } from '../../../images/creative_buzz_badge.svg';
import './CreativeBlog.scss';

const CreativeBlog = ({
  blog
}) => {

  const {
    node : {
      feature_image,
      title,
      excerpt,
      tags,
      primary_author : {
        name,
        profile_image
      },
      published_at,
      slug
    }
  } = blog;

  const eventTags = tags?.splice(0,2);
  
  const idx = tags.findIndex(item => item.slug === 'hash-creatives');
  const badge = idx !== -1 ? creativeBadge : creativeBuzzBadge;
   

  const openBlog = () => window.open(`https://www.noissue.co/blog/${slug}`, '_blank', 'noopener');

  return (
    <>
    {
      feature_image && 
      <div className="creative-blog-item-container" role="presentation" onClick={()=>openBlog()}>  
        <CommunityImg className="creative-blog-item-badge" src={badge} alt="badge" />
        <div className="creative-blog-item-image">
          <CommunityImg src={feature_image} alt="blog img" />
        </div>
        <div className="creative-blog-item-details">
          <div className="creative-blog-item-details-title">
            <div className="creative-blog-item-details-company">
              {title}
            </div>
            <div className="creative-blog-item-details-location">
              {excerpt}
            </div>
          </div>
          <div className="creative-blog-item-details-readmore">Read More</div>
          <div className="creative-blog-item-publisher">
           <div
            className="creative-blog-item-logo-image"
            style={{ backgroundImage: `url(${profile_image})` }}
          />
          <div className="creative-blog-item-publisher-details">
            <span className="creative-blog-item-publisher-name">by {name}</span>
            <span className="creative-blog-item-publisher-published">{published_at}</span>
          </div>
          </div>
          <div className="creative-blog-item-details-tags">
            {
              eventTags.map((tagItem, indx) => {
                return <span key={`tag-${indx}`}>{tagItem.name}</span>
              })
            }
          </div>
        </div>
      </div>
    }
    </>
  )
}

export default CreativeBlog;
